import { ShortenedWarranty } from './../../models/shortened-warranty.model';
import { ErrorResponse } from './../../models/error.model';
import { DocumentsService } from './../../services/documents.service';
import { Component, OnInit, ViewChild, TemplateRef } from '@angular/core';
import { PageEvent } from '@angular/material/paginator';
import { UtilsService } from '../../services/utils.service';
import { GuarantiesService } from '../../services/guaranties.service';
import { PaginatorStatus, DataTableColumn, SortConfiguration } from '../generics/data-table/data-table.component';
import { ID } from '../../models/ID.model';

@Component({
    selector: 'app-digital-signatures',
    templateUrl: './digital-signatures.component.html',
    styleUrls: ['./digital-signatures.component.scss']
})
export class DigitalSignaturesComponent implements OnInit {

    @ViewChild('buttonsColumnTemplate', { static: true })
    buttonsColumnTeplate: TemplateRef<any>;

    guarantiesPaginatorStatus: PaginatorStatus = {
        itemsPerPage: 50,
        page: 0,
        totalElementCount: 0
    };

    columns: DataTableColumn[] = [
        { name: 'ID', prop: 'id' },
        { name: 'Alquiler', prop: 'cotizacionAlquiler', type: 'money' },
        { name: 'Expensas', prop: 'cotizacionExpensas', type: 'money' },
        { name: 'E-Mail', prop: 'emailInquilinoPrincipal', sortable: true, type: 'email' },
        { name: '', width: '400px' }
    ];

    guarantiesSortConfiguration?: SortConfiguration;

    guaranties: ShortenedWarranty[];

    constructor(
        private guarantiesService: GuarantiesService,
        private documentsService: DocumentsService,
        private utilsService: UtilsService
    ) { }

    ngOnInit(): void {
        this.columns.find(col => col.name === '').template = this.buttonsColumnTeplate;
        this.getGuaranties();
    }

    getGuaranties() {
        this.guarantiesService.getGuarantees(this.guarantiesPaginatorStatus.page, this.guarantiesPaginatorStatus.itemsPerPage, this.guarantiesSortConfiguration ? [this.guarantiesSortConfiguration] : [], { estado: 'FIRMA_DIGITAL' })
            .subscribe(response => {
                this.guarantiesPaginatorStatus.totalElementCount = parseInt(response.headers.get('pagination-total-count') ?? '0', 10);
                this.guaranties = response.body;
            }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener garantías', error.error?.descripcion));
    }

    updateGuaranties(event: PageEvent) {
        this.guarantiesPaginatorStatus.itemsPerPage = event.pageSize;
        this.guarantiesPaginatorStatus.page = event.pageIndex;
        this.getGuaranties();
    }

    updateGuarantiesSort(event: SortConfiguration) {
        this.guarantiesSortConfiguration = event;
        this.getGuaranties();
    }

    downloadDocument(documentId: ID) {
        // Usar downloadContract que retorna Blob directamente
        this.documentsService.downloadContract(documentId).subscribe(
            ({ blob, filename }) => {
                this.utilsService.downloadBlobAsFile(blob, filename);
            },
            (error: ErrorResponse) => {
                this.utilsService.alert('Error al descargar archivo', error.error?.descripcion);
            }
        );
    }

    downloadAllPendingContracts() {
        this.guarantiesService.getGuarantees(0, 1000, [], { estado: 'FIRMA_DIGITAL' }).subscribe(response => {
            response.body.forEach(warranty => {
                if (warranty.contratosContratoGarantiaId)
                    this.downloadDocument(warranty.contratosContratoGarantiaId);
            });
        }, (error: ErrorResponse) => this.utilsService.alert('Error al obtener garantías', error.error?.descripcion));
    }

    uploadFiles(event: Event) {
        const files = Array.from((event.target as HTMLInputElement).files);
        if (files?.length) {
            const errors: string[] = [];
            const documentIds: ID[] = [];
            let inProgress = 0;

            for (const file of files) {
                inProgress++;
                // Extraer ID de garantía del nombre del archivo
                const warrantyId = this.extractWarrantyIdFromFilename(file.name);

                if (!warrantyId) {
                    errors.push(`Nombre de archivo inválido: ${file.name}`);
                    inProgress--;
                    if (inProgress === 0) {
                        this.reportUploadedContracts(documentIds, errors);
                    }
                    continue;
                }

                console.log(`Subiendo ${file.name} → Garantía ID: ${warrantyId}`);
                this.documentsService.uploadDocumentAWS(file, 'CONTRATO', warrantyId, 'GARANTIA', true).then(document => {
                    documentIds.push(document.id);
                    inProgress--;
                    if (inProgress === 0) {
                        this.reportUploadedContracts(documentIds, errors);
                    }
                }).catch(_ => errors.push('Error al subir el archivo ' + file.name));
            }
        }
    }
    private extractWarrantyIdFromFilename(filename: string): number | null {
        // Formato: "GARANTIA-7602-28112025130535-53997.pdf"
        const match = filename.match(/GARANTIA-(\d+)-/);
        return match && match[1] ? parseInt(match[1], 10) : null;
    }

    async reportUploadedContracts(documentIds: ID[], errors: string[]) {
        if (documentIds.length) {
            try {
                await this.documentsService.reportSignedDocuments(documentIds).toPromise();
            } catch {
                errors = ['Falló la subida de todos los archivos, por favor vuelva a intentarlo más tarde'];
            }
        } else {
            errors = ['Falló la subida de todos los archivos, por favor vuelva a intentarlo más tarde'];
        }

        const title = errors.length ? 'Hubo algunos errores' : 'Documentos subidos correctamente';
        let description = 'Todos los contratos subidos fueron marcados como firmados, ya puede continuar con el flujo.';
        if (errors.length) {
            description = 'Tuvimos los siguientes errores:\n';
            errors.forEach(error => description += error + '\n');
        }
        this.utilsService.alert(title, description);
        this.getGuaranties();
    }
}
